import * as React from "react"
export const UserAddIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    className="stroke-fg-1"
    height={22}
    viewBox="0 0 25 25"
    fill="none"
    {...props}>
    <path
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.821}
      d="M12.138 15.951H7.586c-1.411 0-2.117 0-2.691.174a4.046 4.046 0 0 0-2.698 2.698c-.174.574-.174 1.28-.174 2.692m17.196 0v-6.07m-3.034 3.035h6.069M14.667 7.859a4.552 4.552 0 1 1-9.104 0 4.552 4.552 0 0 1 9.104 0Z"
    />
  </svg>
)
